import { render, staticRenderFns } from "./FollowUpDetails.vue?vue&type=template&id=64d63dd2&"
import script from "./FollowUpDetails.vue?vue&type=script&lang=ts&"
export * from "./FollowUpDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64d63dd2')) {
      api.createRecord('64d63dd2', component.options)
    } else {
      api.reload('64d63dd2', component.options)
    }
    module.hot.accept("./FollowUpDetails.vue?vue&type=template&id=64d63dd2&", function () {
      api.rerender('64d63dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/discharge/FollowUpDetails.vue"
export default component.exports